<template>
  <div class="row q-col-gutter-x-sm">
    <div
      v-for="option in calculationFrequencyOptions"
      :key="option.value"
      class="col"
    >
      <SAICardToggle
        :disable="disable"
        :error="error"
        class="q-py-md"
        :active="option.value === value"
        @click="$emit('input', option.value)"
      >
        <p class="text-weight-medium text-no-wrap text-center">
          {{ option.label }}
        </p>
      </SAICardToggle>
    </div>
  </div>
</template>

<script>
import { SAICardToggle } from 'ecx.saigon.ui.common';

export default {
  name: 'FrequenciesList',
  props: {
    value: undefined,
    disable: Boolean,
    error: Boolean
  },
  data() {
    return {
      calculationFrequencyOptions: Object.values(
        this.$Constants.CALCULATION_FREQUENCIES
      )
    };
  },
  components: {
    SAICardToggle
  }
};
</script>
